import { Component, Inject, OnInit, ViewEncapsulation, Injector, ViewChild } from '@angular/core';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonDataModel } from 'src/app/shared/common-data-model';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-orders-delivery-details',
  templateUrl: './orders-delivery-details.component.html',
  styleUrls: ['./orders-delivery-details.component.scss']
})
export class OrdersDeliveryDetailsComponent extends AppComponentBase implements OnInit {

  @ViewChild('grid', { static: true }) private grid: GridComponent;
  ordersDataModel = new CommonDataModel();
  selectedCategory: any;
  gridItems = this.ordersDataModel.withoutPaginationReportsGridModel;
  isFormLoading = false;
  deliveryDetailsData: any;
  isJob: any;

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<OrdersDeliveryDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(injector);
    this.isJob = (this.router.url.indexOf('/quotes-list') !== -1) ? false : true;
    this.deliveryDetailsData = data;
   }

  ngOnInit() {
    this.deliveryDetailsData = this.data;
    this.getOrderInShopPendingDetails();
  }

  getOrderInShopPendingDetails(){
    let filterQuery = `?JobId=${this.deliveryDetailsData.dataItem.jobId}`;
    this.kendogridHelper.showLoadingIndicator()
    this.commonService.getOrderInShopPendingDetails(filterQuery)
    .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe((response: any) => {
      if (response.isSuccess) {
        this.gridItems.data = response.data;
        this.gridItems.total = response.data.length;
        this.kendogridHelper.hideLoadingIndicator();
      } else {
        this.toastr.error(response.errors, 'Error!');
      }
    });
  }


  onSubmit() {
    this.dialogRef.close(true);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
